import { MarkResourceInterface } from '../../domain/interface/mark_resource_interface';
import { UserResourceRepository } from '../../domain/repository/user_resource_repository';
import { UserResourceApiService } from '../data_source/user_resource_api_service';

export class UserResourceRepositoryImpl implements UserResourceRepository {
  private readonly userResourceApiService: UserResourceApiService;

  constructor() {
    this.userResourceApiService = new UserResourceApiService();
  }

  async markResourceAsViewed(data: MarkResourceInterface): Promise<void> {
    const response = await this.userResourceApiService.markResourceAsViewed(data);
    return response.data;
  }
}
